
import { Component, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import type { StudyReviewDataSource as DataSource } from '@xt/client/types/course'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiCourse } from '@xt/client'

@Observer
@Component({
  components: {}
})
export default class StudyReview extends Vue {
  visible = false

  dataSource: DataSource | null = null

  isLoading: boolean = true

  CourseReviewToken: string = ''

  // export
  showReview(data: DataSource) {
    this.dataSource = data
    this.onVisible(true)
  }

  onVisible(isShow: boolean) {
    this.visible = isShow
  }

  isCreateTime(data) {
    return data && data.createTime
  }

  async visibleQrcodeChange(visible) {
    if (!this.dataSource) return

    if (visible) {
      this.isLoading = true
      const [, token] = await $service<string>({
        method: 'GET',
        url: EnumApiCourse.CourseToken,
        data: { id: this.dataSource.courseId }
      })

      if (token) {
        this.CourseReviewToken = token
      }
      this.isLoading = false
    }
  }

  // 弹窗被完全关闭
  handleClosed() {
    console.log("弹窗被完全关闭")
  }

  /** 分享二维码 */
  setQrcode() {
    if (!this.dataSource) return ''

    return `${window.location.origin}/activitys/reviewshare?id=${this.dataSource.courseId}&token=${this.CourseReviewToken}`
  }

  getPopupContainer() {
    return this.$refs.popover
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
